module.exports = __webpack_public_path__ + "static/img/22153C_3_4_C_20230601_LC.f9608ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/22153C_3_4_C_20230601_LC.png
// module id = IBpy
// module chunks = 0